export default "__VITE_PUBLIC_ASSET__83bf4bce__"